module.exports = __webpack_public_path__ + "static/Scala-a0085e953362ad490b716517c564edfc.png";